/**
 * Enum for Product Literal IDs.
 */
export enum ProductLiteralIds {
  portfolio = 'portfolio'
}

/**
 * Enum for Product IDs.
 */
export enum ProductIds {
  ddi = 'ddi'
}
